import React from 'react';
import './SuccessMessage.css';

function SuccessMessage({ message }) {
    if (!message) return null;

    return (
        <div className="success-message">
            <i className="fas fa-check-circle"></i>
            <span>{message}</span>
        </div>
    );
}

export default SuccessMessage; 